import { useEffect } from "react";



export const useUpdateFiltersAndSearchInSessionStorage = ({
    dontUpdateCondition = false,
    activeFilters,
    sessionStorageKey
}) => {
     useEffect(() => {
        if(dontUpdateCondition) return; //cuz we wanna remember filters only in the PublishedListing context
    
        const existingData = sessionStorage.getItem(sessionStorageKey);
        
        if (existingData) {
          const parsedData = JSON.parse(existingData);
          const updatedData = {
            ...parsedData,
            activeFilters: activeFilters || []
          };
          sessionStorage.setItem(sessionStorageKey, JSON.stringify(updatedData));
        } else {
          const toSet = {
            searchTerm: '',
            activeFilters: activeFilters || []
          };
          sessionStorage.setItem(sessionStorageKey, JSON.stringify(toSet));
        }
      }, [activeFilters, sessionStorageKey, dontUpdateCondition]);
}